<script lang="ts">
    import { navigate } from 'svelte-routing';
    import { onMount } from 'svelte';
    import { _ } from 'svelte-i18n';

    import GeocodingStatusWithProgressBar from './GeocodingStatusWithProgressBar.svelte';
    import TemplateHeaderDuo from '../../shared/TemplateHeaderDuo.svelte';
    import TemplateStandard from '../../shared/TemplateStandard.svelte';
    import MessageNotFound from '../../shared/Messages/MessageNotFound.svelte';
    import MessageDanger from '../../shared/Messages/MessageDanger.svelte';
    import { mainMenu } from '../../../stores/store';
    import { NotificationSystem } from '../NotificationSystem/NotificationSystem';

    let progressPercent: number = 0;
    let error: string = '';

    // onMount(() => {
    //     $mainMenu.currentPage = 'PageGeocoding';
    // });

    $: {
        if (progressPercent >= 100) {
            $NotificationSystem.reload();
            console.log('currentPage', $mainMenu.currentPage);
            switch ($mainMenu.currentPage) {
                case 'PageJobs': {
                    navigate('/');
                    break;
                }
                case 'PageConnection': {
                    navigate('/connections');
                    break;
                }
                default: {
                    navigate('/');
                }
            }
        }
    }
</script>

<TemplateStandard>
    <div slot="submenu"></div>
    <div slot="header" style="width: 100%;">
        <TemplateHeaderDuo>
            <div slot="main-header">
                {$_('Geocoding')}
            </div>
            <div slot="main-buttons"></div>
        </TemplateHeaderDuo>
    </div>
    <div slot="content">
        <div
            style="display: flex; align-items: center; justify-content: center; padding: 40px 20px; flex-direction: column;"
        >
            <GeocodingStatusWithProgressBar bind:progressPercent bind:error />
            <MessageNotFound text={$_('inform_user_about_action_after_geocoding')} />
            {#if error}
                <MessageDanger header="Error" message="Failed to check status" {error} />
            {/if}
        </div>
    </div>
</TemplateStandard>

<style>
</style>
